import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import { Controller } from 'react-hook-form';

const SelectInput = ({
  id,
  name,
  error,
  control,
  errorLabel,
  defaultValue,
  rules,
  className,
  children,
  disabled,
  variant = 'standard',
  fullWidth = true,
  getHelperTextFromValue,
  sx,
  label,
  disableUnderline,
}) => (
  <FormControl fullWidth={fullWidth} sx={sx} className={className} error={error} variant={variant}>
    {label && <InputLabel htmlFor={id}>{label}</InputLabel>}
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      rules={rules}
      error={error}
      render={({ field }) => (
        <>
          <Select disableUnderline={disableUnderline} disabled={disabled} id={id} {...field}>
            {children}
          </Select>
          {getHelperTextFromValue && <FormHelperText>{getHelperTextFromValue(field.value)}</FormHelperText>}
        </>
      )}
    />
    {error && <FormHelperText>{errorLabel}</FormHelperText>}
  </FormControl>
);

export default SelectInput;
